import { FileDisplayResource } from '../../../../components';
import {
  DateTimeDisplayMode,
  formatDateTime,
} from '../../../../components/DateTimeDisplay';
import { NOOP } from '../../../../constants';
import { useEventHandler } from '../../../../hooks/useEventHandler';
import { useCreateDocumentFile } from '../useCreateDocumentFile';
import { useUpdateOrCreateDocument } from '../useUpdateOrCreateDocument';

export const useUploadDoc = () => {
  const { updateOrCreateDocument } = useUpdateOrCreateDocument();
  const { createDocumentFile } = useCreateDocumentFile();

  const onUploadCallback = useEventHandler(
    async (
      documentPath: string[],
      file: File,
      metaData: Record<string, unknown> = {},
      callback: () => void = NOOP,
    ): Promise<FileDisplayResource> => {
      const [doc] = await updateOrCreateDocument({
        data: {
          status: 'Unchecked',
          uploadedAt: formatDateTime(new Date(), DateTimeDisplayMode.Rfc3339),
          ...metaData,
        },
        definition: 'doc',
        documentPath,
      });

      const response = await createDocumentFile({
        documentId: doc.id,
        documentParams: { definition: 'doc' },
        file,
      });

      if (response?.data?.file) {
        callback();
        return {
          filename: response.data.file.filename,
          id: response.data.file.id,
        };
      }

      throw new Error('Failed handlers.onUploadCallback()');
    },
  );

  return {
    onUploadCallback,
  };
};
